/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Submit_Enrich_Stage_ValidateInputs */

const en_directory_submit_enrich_stage_validate = /** @type {(inputs: Directory_Submit_Enrich_Stage_ValidateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Validation`)
};

const zh_directory_submit_enrich_stage_validate = /** @type {(inputs: Directory_Submit_Enrich_Stage_ValidateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`质量校验`)
};

/**
* | output |
* | --- |
* | "Validation" |
*
* @param {Directory_Submit_Enrich_Stage_ValidateInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_enrich_stage_validate = /** @type {((inputs?: Directory_Submit_Enrich_Stage_ValidateInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Enrich_Stage_ValidateInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_enrich_stage_validate(inputs)
	return zh_directory_submit_enrich_stage_validate(inputs)
});
export { directory_submit_enrich_stage_validate as "directory.submit.enrich.stage.validate" }